import * as R from "ramda";
export const FileTypes = {
	DeathCertificate: "DeathCertificate",
	Signature: "Signature",
	Letter: "Letter",
	TransportationInvoice: "Death.UnderTaker.TransportationInvoice",
	FuneralServicesInvoice: "Death.UnderTaker.Invoice",
	UserRepresentativeHeirProof: "UserRepresentative.Heir.Proof",
	UserRepresentativeRib: "UserRepresentative.Rib",
	UserRepresentativeIdCard: "UserRepresentative.IdCard",
	UserRepresentativeHealthCertificate: "UserRepresentative.HealthCertificate",
	UserRepresentativeFiscalSituation: "UserRepresentative.FiscalSituation",
	UserRepresentativeInvalidPensionCertificate: "UserRepresentative.InvalidPensionCertificate",
	UserRepresentativeWorkDiseasePensionCertificate: "UserRepresentative.WorkDiseasePensionCertificate",
	UserRepresentativeWorkIncidentPensionCertificate: "UserRepresentative.WorkIncidentPensionCertificate",
	UserRepresentativeRetiredPensionCertificate: "UserRepresentative.RetiredPensionCertificate",
	UserPensionProof: "User.PensionProof",
	UserSocialSecurityCard: "User.SocialSecurityCard",
	UserSocialSecurityRightCertificate: "User.SocialSecurityRightCertificate",
	UserRetiredPensionCertificate: "User.RetiredPensionCertificate",
	UserInvalidPensionCertificate: "User.InvalidPensionCertificate",
	UserChildrenIdCard: "User.Children.IdCard",
	UserIdCard: "User.IdCard",
	UserFamilyRecordBook: "User.FamilyRecordBook",
	UserDonation: "User.Donation",
	Other: "Other",
	ProfilePicture: "ProfilePicture",
	Folder: "Folder",
	FolderRH: "FolderRH",
	Payslip: "Payslip",
	UserProofOfAddress: "User.ProofOfAddress",
	LastTaxNotice: "Tax.LastTaxNotice",
	BankAccountSheet: "Bank.AccountSheet",
	Deposit: "Guarantee",
	ThreeMonthOldProofOfAddress: "User.ThreeMonthOldProofOfAddress",
	VaccinationCard: "User.VaccinationCard",
	RegistrationCertificate: "User.RegistrationCertificate",
	RelocationExpenses: "Relocation.Expenses",
	FamilyBook: "User.FamilyBook",
	WorkContract: "User.WorkContract",
	MedicalCertificate: "User.DoctorCertificate",
	IdCard: "IdCard",
	ProtectiveMeasure: "ProtectiveMeasure",
	VisualImpairment: "VisualImpairment",
	SocialSecurityCertificate: "SocialSecurityCertificate",
	LeaseContract: "LeaseContract",
	YearOldProofOfAddress: "User.YearOldProofOfAddress",
	HigherEducationRegistration: "HigherEducationRegistration",
};

export function FiletypeToDisplayName(fileType, isFacilita) {
	if (R.isNil(isFacilita)) {
		isFacilita = true;
	}
	const displayNameMapping = {
		[FileTypes.DeathCertificate]: "Acte de décès",
		[FileTypes.Signature]: "Signature",
		[FileTypes.Letter]: "Lettre",
		[FileTypes.TransportationInvoice]: "Facture des frais de transport du corps",
		[FileTypes.FuneralServicesInvoice]: "Facture des pompes funèbres",
		[FileTypes.UserRepresentativeHeirProof]: "Certificat de notoriété attestant de ma qualité d’héritier",
		[FileTypes.UserRepresentativeRib]: "RIB du référent",
		[FileTypes.UserRepresentativeIdCard]: "Pièce justificative de l'identité du référent",
		[FileTypes.UserRepresentativeHealthCertificate]: "Certificat médical constatant de l'incapacité du référent",
		[FileTypes.UserRepresentativeFiscalSituation]: "Situation fiscale du référent",
		[FileTypes.UserRepresentativeInvalidPensionCertificate]: "Notification du référent pour l'attribution pension d'invalidité",
		[FileTypes.UserRepresentativeWorkDiseasePensionCertificate]: "Notification du référent pour l'attribution de rente pour maladie professionnelle ",
		[FileTypes.UserRepresentativeWorkIncidentPensionCertificate]: "Notification du référent pour l'attribution de rente pour accident du travail",
		[FileTypes.UserRepresentativeRetiredPensionCertificate]: "Notification du référent d'attribution de pension de retraite",
		[FileTypes.UserPensionProof]: "Attestation de rente du défunt (MP ou AT)",
		[FileTypes.UserSocialSecurityCard]: "Carte vitale du défunt",
		[FileTypes.UserSocialSecurityRightCertificate]: "Attestation de droits du défunt",
		[FileTypes.UserRetiredPensionCertificate]: "Notification d'attribution de pension d'invalidité du défunt",
		[FileTypes.UserInvalidPensionCertificate]: "Notification d'attribution de pension de retraite du défunt",
		[FileTypes.UserChildrenIdCard]: "Pièces justificatives de l'identité des enfants à charge du défunt",
		[FileTypes.UserIdCard]: isFacilita ? "Pièces justificatives de l'identité du défunt" : "Pièces justificatives de votre identité",
		[FileTypes.UserFamilyRecordBook]: "Livret de famille" + (isFacilita ? " du défunt" : ""),
		[FileTypes.UserDonation]: "Donation" + (isFacilita ? " du défunt" : ""),
		[FileTypes.Other]: "Autres",
		[FileTypes.ProfilePicture]: "Image de profil",
		[FileTypes.Payslip]: "Bulletin de paie",
		[FileTypes.UserProofOfAddress]: "Justificatif de domicile à votre nom",
		[FileTypes.LastTaxNotice]: "Dernier avis d'imposition",
		[FileTypes.BankAccountSheet]: "Relevé d'identité bancaire",
		[FileTypes.Deposit]: "Bail",
		[FileTypes.ThreeMonthOldProofOfAddress]: "Justificatif de domicile de moins de 3 mois",
		[FileTypes.VaccinationCard]: "Carnet de vaccination",
		[FileTypes.RegistrationCertificate]: "Certificat d'inscription délivré par la mairie",
		[FileTypes.RelocationExpenses]: "Tous les justificatifs des dépenses liées au déménagement : Facture déménageur professionnel OU factures achat de matériel, location de camion, essence et péages...",
		[FileTypes.FamilyBook]: "Livret de famille (si enfant(s) à charge)",
		[FileTypes.WorkContract]: "Contrat de travail et avenant ou attestation de l'employeur",
		[FileTypes.MedicalCertificate]: "Certificat médical à faire remplir par un médecin",
		[FileTypes.IdCard]: "Photocopie de votre carte d’identité recto verso",
		[FileTypes.ProtectiveMeasure]: "Photocopie éventuelle du jugement si une mesure de protection a été prise à votre encontre",
		[FileTypes.VisualImpairment]: "Bilan ophtalmologique ou auditif si vous êtes malvoyant ou malentendant",
		[FileTypes.SocialSecurityCertificate]: "Attestation de Sécurité Sociale",
		[FileTypes.LeaseContract]: "Copie complète du bail souscrit",
		[FileTypes.YearOldProofOfAddress]: "Copie de la facture des dépenses engagées à votre nom et datant de moins d'un an",
		[FileTypes.HigherEducationRegistration]: "Justificatif d'inscription dans l'établissement correspondant au vœu hors académie de résidence que vous avez accepté dans Parcoursup",
	};
	return displayNameMapping[fileType];
}
